"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bsv = void 0;
//const scryptlib_1 = require("scryptlib");
const scryptlib_1 = require("../../../../bsv");
/*
Object.defineProperty(exports, "bsv", { enumerable: true, get: function () { return scryptlib_1.bsv; } });
scryptlib_1.bsv.PrivateKey.prototype.toByteString = function () {
    return this.toHex();
};

*/
Object.defineProperty(exports, "bsv", { enumerable: true, get: function () { return scryptlib_1; } });
scryptlib_1.PrivateKey.prototype.toByteString = function () {
    return this.toHex();
};
//# sourceMappingURL=privateKey.js.map